import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { makeStyles } from '@mui/styles';
import { CONSTANTS, palette } from '@livable/saas-react-components';
import helpers from 'src/styles/helpers';
const useStyles = makeStyles(_objectSpread(_objectSpread({}, helpers), {}, {
  allocationPage: {
    backgroundColor: palette.common.white,
    borderTop: "1px solid ".concat(palette.shades[300])
  },
  allocationTitle: {
    display: 'flex',
    alignItems: 'center',
    padding: '24px 32px 16px 32px'
  },
  allocationContent: {
    display: 'flex',
    alignItems: 'flex-start',
    '& >div + div': {
      borderLeft: "1px solid ".concat(palette.shades[300])
    }
  },
  noUtilitiesHint: {
    display: 'flex',
    padding: '24px 32px',
    alignItems: 'center',
    background: '#fcfcfd',
    justifyContent: 'center',
    height: 'calc(100vh - 280px)'
  },
  smartNav: {
    overflow: 'hidden',
    position: 'relative',
    '&.close': {
      width: '54px'
    }
  },
  smartNavContent: {
    width: '260px',
    backgroundColor: palette.common.white
  },
  smartNavControll: {
    display: 'flex',
    fontSize: '13px',
    fontWeight: '600',
    cursor: 'pointer',
    alignItems: 'center',
    padding: '8px 8px 0 24px',
    justifyContent: 'space-between',
    fontFamily: palette.fontFamilies.poppins,
    '& span': {
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis'
    },
    '&.close': {
      width: '54px',
      padding: '8px 8px 0 8px',
      justifyContent: 'center',
      '& span:first-child': {
        display: 'none'
      },
      '& .MuiSvgIcon-root': {
        transform: 'rotateZ(180deg)'
      },
      '&:after': {
        left: '0',
        right: '0',
        bottom: '0',
        top: '32px',
        zIndex: '98',
        content: '""',
        position: 'absolute',
        transition: 'all .3s ease',
        backgroundColor: '#ffffff'
      },
      '&:before': {
        left: '0',
        right: '0',
        top: '82px',
        bottom: '0',
        zIndex: '99',
        display: 'flex',
        fontSize: '18px',
        fontWeight: '600',
        color: '#8895a7',
        content: '"Companies"',
        position: 'absolute',
        alignItems: 'center',
        justifyContent: 'center',
        transform: 'rotate(-90deg)',
        fontFamily: 'Poppins, sans-serif'
      }
    }
  },
  adminSelectItem: {
    display: 'flex',
    cursor: 'pointer',
    position: 'relative',
    alignItems: 'center',
    padding: '12px 8px 12px 12px',
    justifyContent: 'space-between',
    '&.loader-item': {
      position: 'absolute',
      width: '100%',
      background: 'white',
      zIndex: 9999
    },
    '&.hidden': {
      display: 'none'
    },
    '&:before': {
      top: '50%',
      right: '0',
      width: '4px',
      opacity: '0',
      content: '""',
      height: '24px',
      display: 'block',
      marginTop: '-12px',
      position: 'absolute',
      backgroundColor: palette.primary.main,
      transition: 'all .3s ease',
      borderRadius: '4px 0px 0px 4px'
    },
    '&:hover': {
      backgroundColor: palette.shades[200],
      '& .icon': {
        borderRadius: '8px',
        backgroundColor: '#ACECEF'
      },
      '&:before': {
        opacity: '1'
      }
    },
    '&.active': {
      backgroundColor: palette.shades[250],
      '&:after': {
        top: '0',
        right: '0',
        bottom: '0',
        width: '4px',
        content: '""',
        display: 'block',
        position: 'absolute',
        backgroundColor: palette.primary.main,
        borderRadius: '4px 0px 0px 4px'
      }
    },
    '&.empty': {
      display: 'block',
      textAlign: 'center',
      '& i': {
        fontStyle: 'normal'
      }
    }
  },
  adminSelectItemTooltip: {
    padding: '12px',
    fontSize: '13px',
    lineHeight: '16px',
    borderRadius: '2px',
    margin: '-14px -18px',
    color: palette.common.white,
    backgroundColor: '#212934',
    fontFamily: palette.fontFamilies.poppins,
    boxShadow: '0px 10px 25px 0px rgba(184, 196, 206, 0.20)'
  },
  adminSelectItemData: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    overflow: 'hidden',
    '& > span': {
      display: 'flex',
      alignItems: 'center',
      width: '100%',
      overflow: 'hidden'
    }
  },
  adminSelectItemActions: {
    '& .MuiButton-root': {
      minWidth: 'unset',
      minHeight: 'unset',
      width: '28px',
      height: '28px',
      margin: 'unset',
      padding: 'unset',
      marginLeft: '8px',
      '& .MuiSvgIcon-root': {
        width: '16px',
        height: '16px'
      }
    }
  },
  adminSelectItemProperties: {
    marginRight: '12px',
    '& .MuiChip-root': {
      display: 'flex',
      fontSize: '12px',
      padding: '1px 5px',
      '& + .MuiChip-root': {
        marginLeft: '0',
        marginTop: '2px'
      },
      '& .MuiSvgIcon-root': {
        width: '14px',
        height: '14px',
        marginRight: '3px'
      }
    }
  },
  adminSelectItemsDetails: {
    overflow: 'hidden',
    '& span': {
      display: 'block',
      color: palette.common.black,
      fontSize: '13px',
      fontWeight: '600',
      overflow: 'hidden',
      lineHeight: '16px',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      fontFamily: palette.fontFamilies.poppins
    }
  },
  adminSelectItemsTags: {
    display: 'flex',
    marginTop: '2px',
    flexWrap: 'wrap',
    margin: '-2px 0 0 -2px',
    '& i': {
      display: 'block',
      fontStyle: 'normal',
      borderRadius: '3px',
      padding: '0px 4px',
      lineHeight: '16px',
      fontSize: '13px',
      fontWeight: '600',
      margin: '2px',
      fontFamily: palette.fontFamilies.poppins
    }
  },
  allocationBody: {
    width: '100%',
    overflow: 'hidden',
    height: 'calc(100vh - 75px)',
    '&.paymentMarginWarning': {
      height: 'calc(100vh - 73px - 48px)'
    },
    '&.paymentMarginWarningBoth': {
      height: 'calc(100vh - 73px - 96px)'
    }
  },
  allocationBodyPortfolioHeader: {
    height: '76px',
    display: 'flex',
    padding: '10px 16px',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderBottom: "1px solid ".concat(palette.shades[300])
  },
  allocationBodyPortfolioHeaderTitle: {
    fontSize: '24px',
    fontWeight: '600',
    overflow: 'hidden',
    lineHeight: '28px',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    fontFamily: palette.fontFamilies.poppins
  },
  allocationBodyPortfolioHeaderSubTitle: {
    display: 'flex',
    alignItems: 'center'
  },
  allocationBodyPortfolioHeaderTitleDetails: {
    display: 'flex',
    fontSize: '13px',
    fontWeight: '600',
    alignItems: 'center',
    '&+ div': {
      marginLeft: '8px'
    },
    '& span': {
      color: '#8895A7'
    },
    '& b': {
      color: '#4B617C',
      fontWeight: '600'
    },
    '& i': {
      color: '#259D58',
      fontStyle: 'normal'
    },
    '& > div + div': {
      marginLeft: '17px',
      position: 'relative',
      '&:after': {
        top: '6px',
        left: '-9px',
        bottom: '6px',
        width: '1px',
        content: "''",
        display: 'block',
        position: 'absolute',
        backgroundColor: '#d9d9d9'
      }
    }
  },
  allocationBodyPortfolioHeaderSettings: {
    display: 'flex',
    alignItems: 'center',
    '& > div + div': {
      marginLeft: '8px'
    }
  },
  allocationBodyPortfolioHeaderSettingsTeammembers: {
    display: 'flex'
  },
  allocationBodyPortfolioHeaderSettingsManage: {
    '& .MuiButton-root': {
      height: '48px',
      padding: '12px',
      '& svg': {
        marginRight: '4px'
      }
    }
  },
  allocationBodyPortfolioHeaderSettingsControllerMenu: {
    '& .MuiButton-root': {
      padding: '0',
      width: '48px',
      height: '48px',
      minWidth: '48px',
      minHeight: '48px'
    }
  },
  allocationBodyPortfolioHeaderSettingsView: {
    '& .MuiToggleButton-root': {
      padding: '0',
      width: '48px',
      height: '48px',
      '&.Mui-selected path': {
        fill: 'white'
      }
    }
  },
  lapsedSubscriptionBlocking: {
    top: '0',
    left: '0',
    right: '0',
    bottom: '0',
    zIndex: '22',
    display: 'flex',
    padding: '32px',
    textAlign: 'center',
    position: 'absolute',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'rgba(255,255,255,0.9)'
  },
  allocationBodyPropertyHeader: {
    height: '60px',
    display: 'flex',
    padding: '0 16px',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderBottom: "1px solid ".concat(palette.shades[300])
  },
  allocationBodyPropertyHeaderTitle: {
    display: 'flex',
    alignItems: 'anchor-center',
    fontSize: '18px',
    fontWeight: '600',
    overflow: 'hidden',
    lineHeight: '27px',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    fontFamily: palette.fontFamilies.poppins,
    '& .MuiButton-root': {
      padding: '0',
      minWidth: '36px',
      marginRight: '12px'
    }
  },
  allocationBodyProperty: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between'
  },
  allocationBodyPropertyNav: {
    borderRight: "1px solid ".concat(palette.shades[300])
    // display: 'flex',
    // alignItems: 'flex-start',
    // justifyContent: 'space-between',
  },
  allocationBodyPropertyContent: {
    position: 'relative',
    width: 'calc(100% - 54px)',
    '&.wider': {
      width: 'calc(100% - 300px)'
    },
    '&.fullWidth': {
      width: '100%'
    }
  },
  allocationBodySettings: {
    display: 'flex',
    padding: '16px',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: '-1px',
    borderBottom: "1px solid ".concat(palette.shades[300]),
    borderTop: "1px solid ".concat(palette.shades[300]),
    backgroundColor: palette.shades[200],
    '& > div': {
      margin: '0 4px',
      '&:first-child': {
        marginLeft: '0'
      },
      '&:last-child': {
        marginRight: '0'
      }
    },
    '& .MuiSelect-select': {
      padding: '6px 32px 6px 6px'
    },
    '& .MuiInputBase-input': {
      padding: '6px 6px 6px 12px'
    }
  },
  allocationBodySearch: {
    width: '100%',
    '& > div > div:first-child': {
      top: '6px',
      left: '10px'
    },
    '& .MuiInputBase-input': {
      padding: '6px 6px 6px 40px'
    }
  },
  allocationBodyStatusFilter: {
    minWidth: '260px'
  },
  allocationBodyList: {
    overflowY: 'auto',
    height: 'calc(100vh - 205px)',
    '&.paymentMarginWarning': {
      height: 'calc(100vh - 205px - 53px)'
    },
    '&.paymentMarginWarningBoth': {
      height: 'calc(100vh - 205px - 100px)'
    },
    '&.residents': {
      height: 'calc(100vh - 274px)'
    },
    '& .MuiPaper-root + .MuiPaper-root': {
      marginTop: '1px'
    }
  },
  allocationItem: {
    '& .MuiAccordion-root': {
      boxShadow: 'none',
      '&.Mui-expanded .accordionArrowWrapper div:not(.statementWrapper) .MuiSvgIcon-root': {
        transform: 'rotateZ(180deg)'
      }
    },
    '&:not(:first-child)': {
      marginTop: '-1px'
    },
    '& .MuiChip-root': {
      fontSize: '13px',
      marginLeft: '4px',
      padding: '0px 6px'
    },
    '& + div': {
      borderTop: "1px solid ".concat(palette.shades[300])
    }
  },
  accordionHeader: {
    width: '100%',
    display: 'flex',
    fontSize: '13px',
    fontWeight: '600',
    alignItems: 'center',
    padding: '16px 24px',
    // borderTop: `1px solid ${palette.shades[300]}`,
    justifyContent: 'space-between',
    borderBottom: "1px solid ".concat(palette.shades[300]),
    fontFamily: palette.fontFamilies.poppins
  },
  accordionHeaderTitle: {
    '& i': {
      fontSize: '11px',
      display: 'block',
      color: palette.shades[700],
      fontWeight: '700',
      lineHeight: '14px',
      fontStyle: 'normal',
      fontFamily: palette.fontFamilies.source
    }
  },
  accordionHeaderDetails: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'right',
    '& span': {
      color: palette.shades[700],
      marginRight: '2px'
    }
  },
  accordionHeaderDetailsData: {
    '& div:not(:first-child)': {
      fontFamily: palette.fontFamilies.source
    }
  },
  accordionHeaderDetailsIcon: {
    marginLeft: '4px'
  },
  accordionBody: {
    backgroundColor: palette.shades[200]
  },
  accordionBodyItem: {
    display: 'flex',
    alignItems: 'center',
    padding: '12px 24px',
    justifyContent: 'space-between',
    fontFamily: palette.fontFamilies.poppins,
    '&:not(:first-child)': {
      borderTop: "1px solid ".concat(palette.shades[300])
    },
    '&:not(.addCustomTable):hover': {
      backgroundColor: palette.shades[300]
    },
    '&.addCustomTable': {
      padding: '12px 24px 32px 24px',
      '& .MuiButton-root': {
        border: "1px solid ".concat(palette.shades[300])
      }
    }
  },
  accordionBodyItemInfo: {
    display: 'flex',
    alignItems: 'center'
  },
  accordionBodyItemInfoIcon: {
    width: '24px',
    height: '24px',
    marginRight: '16px'
  },
  accordionBodyItemInfoDetails: {
    '& b': {
      color: palette.shades[700],
      fontSize: '15px'
    },
    '& i': {
      fontSize: '14px',
      color: palette.shades[700],
      fontStyle: 'normal',
      fontFamily: palette.fontFamilies.source,
      display: 'block',
      lineHeight: '21px'
    }
  },
  accordionBodyItemInfoDetailsTitle: {
    display: 'flex',
    '& i': {
      marginLeft: '4px'
    }
  },
  accordionBodyItemControl: {
    display: 'flex',
    alignItems: 'center',
    '& > div+ div': {
      marginLeft: '4px'
    }
  },
  priceInfo: {
    borderRadius: '2px',
    border: "1px solid ".concat(palette.shades[300]),
    backgroundColor: palette.shades[200],
    color: palette.common.black,
    fontSize: '13px',
    fontWeight: '600',
    lineHeight: '16px',
    minWidth: '69px',
    padding: '9px 12px',
    textAlign: 'center',
    fontFamily: palette.fontFamilies.poppins
  },
  allocationBodyContentHeader: {
    height: '145px'
  },
  allocationBodyDetailed: {
    backgroundColor: palette.common.white
  },
  newPropertySetupBody: {
    backgroundColor: palette.common.white,
    overflowY: 'scroll',
    height: "calc(100vh - ".concat(CONSTANTS.NEW_HEADER_HEIGHT, "px - 140px)")
  },
  allocationBodyDetailedWrapper: {
    overflowY: 'auto',
    height: 'calc(100vh - 204px)',
    '&.paymentMarginWarning': {
      height: 'calc(100vh - 204px - 53px)'
    },
    '&.paymentMarginWarningBoth': {
      height: 'calc(100vh - 204px - 100px)'
    }
  },
  allocationBodyDetailedWrapperHeader: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: 'white',
    padding: '24px 16px 0 16px',
    justifyContent: 'space-between'
  },
  allocationBodyDetailedWrapperHeaderDetail: {
    display: 'flex',
    alignItems: 'center'
  },
  allocationBodyDetailedWrapperHeaderTitle: {
    display: 'block',
    color: palette.common.black,
    fontSize: '18px',
    fontWeight: '600',
    lineHeight: '27px',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    fontFamily: palette.fontFamilies.poppins
  },
  allocationBodyDetailedWrapperHeaderControllers: {
    display: 'flex',
    alignItems: 'center',
    '& > div + div': {
      marginLeft: '8px'
    }
  },
  allocationBodyDetailedWrapperHeaderControllerManage: {
    '& .MuiSvgIcon-root': {
      marginRight: '4px'
    }
  },
  allocationBodyDetailedWrapperHeaderControllerMenu: {
    '& .MuiButton-root': {
      padding: '0',
      width: '36px',
      height: '36px',
      minWidth: '36px',
      minHeight: '36px'
    }
  },
  allocationBodyDetailedWrapperContent: {},
  allocationBodyDetailedWrapperContentItems: {
    display: 'flex',
    margin: '0 -4px',
    padding: '16px 16px 24px 16px',
    '& > div': {
      padding: '0 4px'
    }
  },
  allocationBodyDetailedWrapperContentItem: {
    width: '100%',
    padding: '16px 16px 24px 16px'
  },
  allocationBodyDetailedWrapperContentItemTitle: {
    color: palette.common.black,
    fontSize: '15px',
    fontWeight: '600',
    marginBottom: '16px',
    fontFamily: palette.fontFamilies.poppins
  },
  allocationBodyDetailedWrapperContentItemSubTitle: {
    color: palette.shades[700],
    fontSize: '13px',
    fontWeight: '600',
    marginBottom: '8px',
    fontFamily: palette.fontFamilies.poppins
  },
  allocationBodyDetailedWrapperContentItemBody: {},
  infoBlocks: {
    display: 'flex',
    alignItems: 'center'
  },
  allocationBodyDetailedWrapperContentItemFooter: {
    marginTop: '8px',
    '& .MuiButton-root': {
      backgroundColor: palette.shades[200],
      border: "1px solid ".concat(palette.shades[300])
    }
  },
  allocationBodyDetailedWrapperContentItemAction: {
    marginTop: '8px',
    '& .MuiButton-root': {
      padding: '11px 18px 11px 11px'
    }
  },
  billAmount: {
    width: 'auto',
    height: 'auto',
    display: 'block',
    minWidth: '80px',
    fontSize: '15px',
    padding: '0 12px',
    borderTop: 'none',
    textAlign: 'right',
    marginRight: '4px',
    color: '#4B617C',
    borderRight: 'none',
    borderBottom: 'none',
    marginLeft: '-4px !important',
    backgroundColor: 'transparent !important',
    '&:first-child': {
      borderLeft: 'none'
    },
    '&.MuiButton-sizeSmall': {
      width: 'auto',
      height: 'auto',
      minWidth: '80px'
    },
    '& span': {
      fontSize: '13px',
      display: 'block',
      color: '#8895A7',
      lineHeight: '16px'
    },
    '&:hover': {
      backgroundColor: '#fff'
    }
  },
  billings: {
    background: palette.gradients.white,
    borderBottom: "1px solid ".concat(palette.shades[300]),
    boxShadow: palette.shadows.light,
    minHeight: '200px'
  },
  disabled: {
    opacity: 0.5
  },
  fileNameIcon: {
    display: 'flex',
    '& .MuiSvgIcon-root': {
      height: '17px',
      marginLeft: '3px',
      marginTop: '3px',
      width: '12px'
    }
  },
  infoBlock: {
    fontSize: '13px',
    padding: '8px 16px',
    borderRadius: '2px',
    backgroundColor: palette.shades[200],
    '&:not(:first-child)': {
      marginLeft: '8px'
    },
    '& b': {
      display: 'block',
      fontWeight: '600',
      '&:first-child': {
        fontSize: '18px',
        fontFamily: palette.fontFamilies.poppins
      }
    },
    '&.success': {
      backgroundColor: palette.success.light
    },
    '&.error': {
      backgroundColor: palette.error.light
    }
  },
  menuBlock: {
    height: '100%',
    padding: '12px',
    fontSize: '13px',
    fontWeight: '600',
    borderRadius: '2px',
    // backgroundColor: palette.common.white,
    backgroundColor: palette.shades[200],
    border: "1px solid ".concat(palette.shades[300]),
    fontFamily: palette.fontFamilies.poppins,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& span': {
      fontSize: '14px',
      fontWeight: '400',
      fontFamily: palette.fontFamilies.source
    }
  },
  menuBlockIcon: {
    width: '48px',
    height: '48px',
    flexShrink: '0',
    marginRight: '8px',
    borderRadius: '2px',
    backgroundColor: palette.common.white,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  menuBlockDetails: {
    width: '100%'
  },
  menuBlockControls: {
    '& .MuiButton-root': {
      border: 'none'
    }
  },
  autoBillingStatus: {
    '& span': {
      marginLeft: '4px'
    },
    '&.activated': {
      '& .MuiSvgIcon-root': {
        '& path': {
          fill: '#259D58'
        }
      },
      '& span': {
        color: '#259D58'
      }
    }
  },
  userCircles: {
    display: 'flex',
    '& span': {
      width: '32px',
      height: '32px',
      display: 'block',
      borderRadius: '50%',
      marginLeft: '-8px',
      border: '1px solid #FFF',
      backgroundColor: palette.info.main,
      color: palette.common.white,
      textAlign: 'center',
      fontFamily: palette.fontFamilies.poppins,
      fontSize: '13px',
      fontWeight: '600',
      lineHeight: '30px',
      '&.other': {
        color: palette.shades[600],
        backgroundColor: palette.shades[300]
      }
    }
  },
  selectWrapper: {
    position: 'relative'
  },
  selectIcon: {
    top: '0',
    zIndex: '1',
    left: '8px',
    width: '24px',
    height: '48px',
    display: 'flex',
    position: 'absolute',
    alignItems: 'center',
    pointerEvents: 'none',
    justifyContent: 'center',
    '& svg path': {
      fill: palette.shades[500]
    }
  },
  selectContent: {
    '& .MuiInputBase-input': {
      paddingLeft: '40px'
    },
    '& .MuiFormLabel-root': {
      paddingLeft: '25px'
    }
  },
  selectPayoutMethodItem: {
    display: 'block',
    '& i': {
      display: 'block',
      fontSize: '12px',
      fontStyle: 'normal'
    },
    '&.disabled': {
      '&:hover': {
        backgroundColor: 'unset',
        cursor: 'default'
      }
    }
  },
  detailsListBox: {},
  detailsListBoxContent: {
    display: 'flex',
    borderRadius: '2px',
    alignItems: 'flex-start',
    backgroundColor: palette.shades[200],
    justifyContent: 'center',
    border: "1px solid ".concat(palette.shades[300]),
    fontSize: '13px',
    fontWeight: '600',
    lineHeight: '20px',
    padding: '12px',
    fontFamily: palette.fontFamilies.poppins
  },
  detailsListBoxIcon: {
    width: '48px',
    height: '48px',
    display: 'flex',
    flexShrink: '0',
    marginRight: '8px',
    borderRadius: '2px',
    alignItems: 'center',
    backgroundColor: palette.common.white,
    justifyContent: 'center'
  },
  detailsListBoxData: {
    width: '100%',
    minHeight: '48px',
    display: 'flex',
    alignItems: 'center',
    '& td': {
      padding: '0',
      paddingRight: '12px',
      verticalAlign: 'top',
      '&:first-child': {
        color: palette.shades[700]
      }
    }
  },
  detailsListBoxEdit: {
    paddingTop: '5px',
    '& .MuiButton-root': {
      border: 'none'
    }
  },
  emptyState: {
    height: '100%'
  },
  emptyStateContainer: {
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    justifyContent: 'center'
  },
  emptyStateContainerItem: {
    display: 'flex',
    textAlign: 'center',
    flexDirection: 'column'
  },
  emptyStateContainerItemAddPropertyButton: {
    marginTop: '32px'
  },
  adminSelectContentFilters: {
    display: 'flex',
    alignItems: 'center',
    padding: '8px 12px 8px 4px',
    justifyContent: 'space-between'
  },
  adminSelectContentFilterSearch: {
    '& .MuiOutlinedInput-notchedOutline': {
      border: 'none'
    },
    '& > div > div:first-child': {
      top: '6px',
      left: '10px'
    }
  },
  adminSelectContentFilterList: {
    flexShrink: '0',
    marginLeft: '8px',
    display: 'flex',
    alignItems: 'center',
    '& .MuiButton-root': {
      width: '28px',
      height: '28px',
      border: 'none',
      padding: '0',
      minWidth: '28px',
      minHeight: '28px',
      '& svg': {
        fontSize: '16px'
      }
    },
    '& > div + div': {
      marginLeft: '4px'
    }
  },
  adminSelectContentList: {
    maxHeight: 'calc(100vh - 158px)',
    overflowY: 'scroll',
    '&.paymentMarginWarning': {
      maxHeight: 'calc(100vh - 158px - 49px)'
    },
    '&.paymentMarginWarningBoth': {
      maxHeight: 'calc(100vh - 158px - 100px)'
    }
  },
  glAccountItem: {
    display: 'block !important',
    '& i': {
      display: 'block',
      fontSize: '11px',
      fontStyle: 'normal'
    }
  },
  glAccountSwitchWrapper: {
    marginBottom: '8px'
  },
  glAccountSwitch: {
    color: palette.common.black,
    fontSize: '13px',
    fontWeight: '600',
    fontFamily: palette.fontFamilies.poppins
  },
  allocationBodyPortfolioHeaderTitleTags: {
    display: 'flex',
    alignItems: 'center'
  },
  allocationBodyPortfolioHeaderTitleTagsTitle: {
    color: palette.shades[600],
    fontSize: '13px',
    fontWeight: '600',
    marginRight: '4px',
    fontFamily: palette.fontFamilies.poppins
  },
  overflowEllipsis: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },
  accordionHeaderDetailsDayLeft: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: palette.success.light,
    padding: '6px 8px 6px 12px',
    color: '#145239',
    marginRight: '48px',
    borderRadius: '99px',
    position: 'relative',
    '&:after': {
      top: '-4px',
      width: '1px',
      content: '""',
      right: '-24px',
      bottom: '-4px',
      display: 'block',
      position: 'absolute',
      backgroundColor: palette.shades[300]
    },
    '& span': {
      marginRight: '4px',
      color: '#145239'
    },
    '& .MuiSvgIcon-root': {
      fontSize: '20px',
      '& path': {
        fill: '#145239'
      }
    },
    '&.error': {
      backgroundColor: palette.error.light,
      '& span': {
        color: palette.error.dark
      },
      '& .MuiSvgIcon-root': {
        '& path': {
          path: '#611818'
        }
      }
    },
    '&.warning': {
      backgroundColor: palette.warning.light,
      '& span': {
        color: palette.warning.main
      },
      '& .MuiSvgIcon-root': {
        '& path': {
          path: '#D5A320'
        }
      }
    }
  },
  paymentAndSubscription: {},
  paymentAndSubscriptionWrapper: {},
  paymentAndSubscriptionHeader: {
    display: 'flex',
    alignItems: 'center',
    padding: '12px 16px 0 16px',
    justifyContent: 'space-between',
    borderBottom: "1px solid ".concat(palette.shades[300])
  },
  paymentAndSubscriptionHeaderTitle: {},
  paymentAndSubscriptionHeaderTabs: {},
  paymentAndSubscriptionBody: {
    display: 'flex'
  },
  paymentAndSubscriptionLsit: {
    width: '220px',
    flexShrink: '0',
    overflow: 'auto',
    height: 'calc(100vh - 146px)',
    borderRight: "1px solid ".concat(palette.shades[300])
  },
  paymentAndSubscriptionUnits: {},
  paymentAndSubscriptionUnit: {
    fontSize: '13px',
    fontWeight: '600',
    cursor: 'pointer',
    lineHeight: '16px',
    position: 'relative',
    padding: '12px 4px 12px 12px',
    '& b': {
      display: 'block',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      fontFamily: palette.fontFamilies.poppins
    },
    '& span': {
      color: palette.shades[700]
    },
    '& i': {
      color: '#259D58',
      fontStyle: 'normal'
    },
    '&:before': {
      top: '50%',
      right: '0',
      width: '4px',
      opacity: '0',
      content: '""',
      height: '24px',
      display: 'block',
      marginTop: '-12px',
      position: 'absolute',
      backgroundColor: palette.primary.main,
      transition: 'all .3s ease',
      borderRadius: '4px 0px 0px 4px'
    },
    '&:hover': {
      backgroundColor: palette.shades[200],
      '&:before': {
        opacity: '1'
      }
    },
    '&.active': {
      backgroundColor: palette.shades[250],
      '&:after': {
        top: '0',
        right: '0',
        bottom: '0',
        width: '4px',
        content: '""',
        display: 'block',
        position: 'absolute',
        backgroundColor: palette.primary.main,
        borderRadius: '4px 0px 0px 4px'
      }
    }
  },
  paymentAndSubscriptionDetails: {
    width: '100%',
    overflow: 'hidden',
    position: 'relative'
  },
  paymentAndSubscriptionDetailsHeader: {
    display: 'flex',
    alignItems: 'center',
    padding: '12px 8px 12px 16px',
    justifyContent: 'space-between',
    borderBottom: "1px solid ".concat(palette.shades[300])
  },
  paymentAndSubscriptionDetailsHeaderDetails: {
    '& b': {
      fontSize: '15px',
      fontWeight: '600',
      display: 'block',
      overflow: 'hidden',
      lineHeight: '22px',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      fontFamily: palette.fontFamilies.poppins
    },
    '& span': {
      display: 'block',
      lineHeight: '22px',
      fontSize: '14px'
    }
  },
  paymentAndSubscriptionDetailsHeaderTabs: {
    '& .MuiTabs-root': {
      minHeight: '100%'
    },
    '& .MuiButtonBase-root': {
      height: 'auto',
      padding: '8px 12px',
      borderRadius: '4px',
      '&.Mui-selected': {
        backgroundColor: palette.shades[300]
      },
      '&:after': {
        display: 'none'
      }
    },
    '& .MuiTabs-indicator': {
      display: 'none'
    }
  },
  paymentAndSubscriptionDetailsBody: {
    height: 'calc(100vh - 255px)',
    overflow: 'auto',
    '& .MuiDataGrid-cell': {
      fontSize: '13px'
    },
    '& .MuiChip-root': {
      fontSize: '13px',
      padding: '2px 6px'
    },
    '& .MuiDataGrid-root': {
      boxShadow: 'none'
    }
  },
  refundLink: {
    color: palette.primary.main,
    textDecoration: 'underline'
    // cursor: 'pointer',
  },
  cellContent: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    '&.disabled': {
      color: palette.shades[500]
    }
  },
  infoButton: {
    marginLeft: '10px'
  },
  invoice: {
    position: 'absolute',
    top: '0',
    left: '0',
    right: '0',
    bottom: '0',
    zIndex: '99',
    overflow: 'auto',
    backgroundColor: palette.common.white
  },
  invoiceWrapper: {},
  invoiceHeader: {
    display: 'flex',
    alignItems: 'center',
    padding: '8px 16px',
    borderBottom: "1px solid ".concat(palette.shades[300])
  },
  invoiceHeaderAction: {
    marginRight: '16px',
    '& .MuiButton-root': {
      minWidth: '36px',
      width: '36px'
    }
  },
  invoiceHeaderDetails: {
    '& b': {
      fontSize: '15px',
      fontWeight: '600',
      display: 'block',
      overflow: 'hidden',
      lineHeight: '22px',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      fontFamily: palette.fontFamilies.poppins
    },
    '& span': {
      display: 'block',
      lineHeight: '22px',
      fontSize: '14px'
    }
  },
  invoiceBody: {
    height: 'calc(100vh - 255px)',
    overflow: 'auto'
  },
  invoiceBodyHeader: {
    display: 'flex',
    alignItems: 'center',
    padding: '24px 16px 16px 16px',
    justifyContent: 'space-between'
  },
  invoiceBodyHeaderTitle: {},
  invoiceBodyHeaderActions: {
    display: 'flex',
    alignItems: 'center'
  },
  invoiceDetails: {
    padding: '0px 16px',
    '& .MuiChip-root': {
      fontSize: '13px',
      padding: '2px 6px'
    },
    '& table': {
      fontSize: '13px',
      fontWeight: '600',
      lineHeight: '24px',
      fontFamily: palette.fontFamilies.poppins
    },
    '& td': {
      padding: '0 32px 0 0',
      '&:nth-child(odd)': {
        color: palette.shades[700],
        paddingRight: '12px'
      }
    }
  },
  invoiceRefund: {},
  invoiceBlockTitle: {
    padding: '0 16px',
    margin: '40px 0 12px 0',
    '&.small': {
      margin: '32px 0 16px 0'
    }
  },
  refundCreditInvoice: {
    '&.white': {
      backgroundColor: palette.common.white
    },
    '& > div': {
      paddingLeft: '32px',
      paddingRight: '32px'
    }
  },
  invoiceRadio: {
    cursor: 'pointer',
    paddingLeft: '32px',
    position: 'relative',
    '&:not(:last-child)': {
      marginBottom: '16px'
    },
    '& .MuiFormControlLabel-root': {
      left: '0',
      top: '-8px',
      position: 'absolute'
    }
  },
  invoiceTextArea: {
    marginTop: '24px',
    '& textarea': {
      width: '100%',
      resize: 'none',
      padding: '12px',
      outline: 'none',
      maxWidth: '100%',
      minWidth: '100%',
      fontSize: '18px',
      lineHeight: '24px',
      borderRadius: '2px',
      border: '1px solid #B8C4CE',
      fontFamily: palette.fontFamilies.source
    }
  },
  invoiceTotal: {
    padding: '0px 16px',
    '& .MuiFormControl-root': {
      width: '100px'
    },
    '& .MuiInputBase-input': {
      paddingTop: '6px',
      textAlign: 'right',
      paddingBottom: '6px'
    },
    '& table': {
      width: '100%',
      fontSize: '13px',
      fontWeight: '600',
      lineHeight: '24px',
      borderSpacing: '0',
      fontFamily: palette.fontFamilies.poppins
    },
    '& thead td': {
      whiteSpace: 'nowrap',
      color: palette.shades[700]
    },
    '& tbody td': {
      borderTop: "1px solid ".concat(palette.shades[300])
    },
    '& td': {
      height: '44px',
      padding: '0 12px',
      textAlign: 'right',
      '&:first-child': {
        width: '100%',
        paddingLeft: '0',
        textAlign: 'left'
      }
    }
  },
  editFees: {
    padding: '0px 16px',
    '& .MuiFormControl-root': {
      width: '120px'
    },
    '& .MuiInputBase-input': {
      // textAlign: 'right',
    },
    '& table': {
      width: '100%',
      fontSize: '18px',
      fontWeight: '600',
      lineHeight: '24px',
      borderSpacing: '0',
      whiteSpace: 'nowrap',
      fontFamily: palette.fontFamilies.poppins
    },
    '& tr:first-child td': {
      borderTop: 'none'
    },
    '& td': {
      height: '64px',
      padding: '0 2px',
      textAlign: 'right',
      borderTop: "1px solid ".concat(palette.shades[300]),
      '&:first-child': {
        width: '100%',
        paddingLeft: '0',
        textAlign: 'left'
      }
    }
  },
  editFeeResetButton: {
    width: '48px',
    padding: '12px',
    minWidth: '48px'
  },
  resetAll: {
    textAlign: 'right',
    '& .MuiButton-root': {
      padding: '12px'
    }
  },
  invoiceDetailsWrapper: {
    padding: '0 16px'
  },
  invoiceDetailsType: {},
  invoiceDetailsTypeWrapper: {
    display: 'flex',
    margin: '0 -6px'
  },
  invoiceDetailsTypeUnit: {
    padding: '6px',
    width: '50%'
  },
  invoiceDetailsTypeUnitWrapper: {
    display: 'flex',
    borderRadius: '2px',
    padding: '12px',
    border: "1px solid ".concat(palette.shades[300]),
    backgroundColor: palette.shades[200]
  },
  invoiceDetailsTypeUnitIcon: {
    width: '48px',
    height: '48px',
    display: 'flex',
    flexShrink: '0',
    marginRight: '12px',
    borderRadius: '4px',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#ACECEF',
    '& path': {
      fill: '#00767C'
    }
  },
  invoiceDetailsTypeUnitDetails: {
    width: '100%',
    '& b': {
      display: 'block',
      fontSize: '13px',
      fontWeight: '600',
      lineHeight: '20px',
      fontFamily: palette.fontFamilies.poppins
    },
    '& i': {
      display: 'block',
      fontSize: '13px',
      color: palette.shades[700],
      lineHeight: '16px',
      fontStyle: 'normal'
    },
    '& span': {
      display: 'block',
      fontSize: '13px',
      color: palette.primary.main,
      marginTop: '8px',
      lineHeight: '16px'
    },
    '&.error span': {
      color: '#C43131'
    }
  },
  invoiceDetailsTypeUnitAction: {
    flexShrink: '0',
    marginLeft: '12px'
  },
  invoiceDetailsBoxTitle: {
    margin: '16px 0 10px 0',
    '&.samll': {
      margin: '0 0 8px 0',
      '& .MuiTypography-root': {
        color: palette.shades[700]
      }
    }
  },
  invoiceCoupon: {
    '& .MuiFormControl-root': {
      minWidth: '432px'
    },
    '& .MuiButton-root': {
      padding: '16px',
      fontSize: '15px',
      marginLeft: '8px'
    }
  },
  invoiceDetailBox: {
    padding: '16px',
    borderRadius: '2px',
    backgroundColor: palette.shades[200],
    border: "1px solid ".concat(palette.shades[300]),
    '& .MuiButton-root': {
      width: '36px',
      padding: '6px',
      minWidth: '36px'
    },
    '& table': {
      width: '100%',
      color: palette.shades[700],
      fontSize: '13px',
      fontWeight: '600',
      lineHeight: '24px',
      borderSpacing: '0',
      whiteSpace: 'nowrap',
      fontFamily: palette.fontFamilies.poppins
    },
    '& thead td': {
      height: '42px',
      fontSize: '18px',
      color: palette.shades[700]
    },
    '& tfoot td': {
      color: palette.common.black,
      borderTop: "1px solid ".concat(palette.shades[300])
    },
    '& tbody tr:first-child td': {
      color: palette.common.black,
      height: '40px',
      paddingTop: '2px'
    },
    '& tr:first-child td': {
      borderTop: 'none'
    },
    '& tfoot tr:first-child td': {
      borderTop: "1px solid ".concat(palette.shades[300])
    },
    '& td': {
      height: '36px',
      padding: '0 6px',
      textAlign: 'right',
      borderTop: "1px solid ".concat(palette.shades[300]),
      '&:first-child': {
        width: '100%',
        paddingLeft: '0',
        textAlign: 'left'
      },
      '&:nth-child(2)': {
        color: palette.common.black
      },
      '&:last-child': {
        paddingRight: '0'
      }
    },
    '&.large td': {
      height: '44px'
    }
  },
  invoiceValue: {
    color: palette.primary.main,
    textDecoration: 'underline'
  },
  removeChargeOnDateButton: {
    marginLeft: '8px',
    display: 'flex',
    '& .MuiButton-root': {
      width: '48px',
      height: '48px',
      minWidth: '48px',
      border: '1px solid #b8c4ce'
    }
  },
  saveCompanyAddressButton: {
    marginLeft: '8px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    alignSelf: 'flex-end',
    '& .MuiButton-root': {
      width: '48px',
      height: '48px',
      minWidth: '48px',
      border: '1px solid #b8c4ce'
    }
  },
  portfolioDetails: {
    width: '100%',
    padding: '0 16px'
  },
  portfolioDetailsHeader: {
    padding: '24px 0 12px 0',
    borderBottom: '1px solid #E1E7EC',
    '&.noBorderBottom': {
      borderBottom: '1px solid transparent'
    }
  },
  portfolioDetailsHeaderActions: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  portfolioDetailsHeaderName: {
    display: 'flex',
    alignItems: 'center',
    '& .MuiButton-root': {
      marginLeft: '8px',
      border: '1px solid transparent'
    }
  },
  portfolioDetailsHeaderActionsList: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    '& > div + div': {
      marginLeft: '16px'
    }
  },
  portfolioDetailsBody: {
    overflow: 'auto',
    height: 'calc(100vh - 298px)'
  },
  portfolioDetailsHeaderSearch: {
    marginTop: '28px'
  },
  searchField: {
    maxWidth: '400px'
  },
  portfolioDetailsHeaderUsersList: {
    display: 'flex',
    textAlign: 'center',
    alignItems: 'center',
    '& span': {
      width: '32px',
      color: '#FFF',
      height: '32px',
      display: 'block',
      fontSize: '13px',
      fontWeight: '600',
      lineHeight: '30px',
      borderRadius: '50%',
      border: '1px solid #FFF',
      backgroundColor: '#2A85D1',
      fontFamily: palette.fontFamilies.poppins,
      '&.total': {
        color: '#8895A7',
        backgroundColor: '#E1E7EC'
      },
      '&:not(:first-child)': {
        marginLeft: '-8px'
      }
    }
  },
  newPortfolioBody: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    justifyContent: 'center',
    height: 'calc(100vh - 224px)',
    '& img': {
      marginBottom: '32px'
    },
    '& .MuiTypography-root + .MuiTypography-root': {
      marginTop: '8px'
    },
    '& .MuiButton-root + .MuiButton-root': {
      marginLeft: '16px'
    },
    '& > div': {
      marginTop: '32px'
    }
  },
  newPortfolioManage: {
    borderRadius: '50%',
    '& .MuiSvgIcon-root': {
      fontSize: '16px'
    }
  },
  accordionBodyAdditionalChargesAndcreditsWarning: {
    marginBottom: '-1px',
    '& .MuiChip-root': {
      margin: '0',
      width: '100%',
      padding: '8px 16px'
    }
  },
  subscriptionChip: {
    '& .MuiChip-label': {
      fontSize: '13px'
    }
  }
}));
export default useStyles;